import React from 'react'
import { Tooltip } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  tooltip: {
    padding: 0,
    fontSize: 'inherit',
    backgroundColor: 'white',
    color: 'black',
  },
}))

const CustomCalendarTooltip = ({ title, description }) => (
  <div
    style={{
      padding: '8px 16px',
      backgroundColor: 'white',
      borderRadius: '8px',
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
    }}
  >
    {title && <p style={{ fontSize: '14px', fontWeight: 'bold' }}>{title}</p>}
    {description && <p style={{ fontSize: '12px' }}>{description}</p>}
  </div>
)

const TooltipWrapper = ({ tooltipComponent, title, description, children }) => {
  if (!tooltipComponent && !title && !description) {
    return children
  }
  return (
    <Tooltip
      title={
        tooltipComponent || (
          <CustomCalendarTooltip title={title} description={description} />
        )
      }
      classes={{ tooltip: useStyles().tooltip }}
      placement="bottom-start"
    >
      {children}
    </Tooltip>
  )
}

export default TooltipWrapper
